export const SUPPORTED_LANGUAGES = ["en", "es", "pt", "fr", "ja"] as const;
export const DEFAULT_LANGUAGE = "en";
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
